<template>
  <div class="" v-track="{ event: 'browse', route: $route, isButton: false }">

    <div class="">


      <div class="contro-map">
        <ControlMap @mapTypeChange="mapChange"></ControlMap>
      </div>
      <div class="Bmap1" id="Bmap1"></div>
      <div class="demo-spin-container" v-if="spinShow">
        <Spin fix></Spin>
      </div>
    </div>
  </div>
</template>

<script>
import { lngLatCommunityList, communitySelectCondition, countyLocation } from '@/api/pledge'
import ControlMap from '@/views/pledge/components/ControlMap.vue'
import CityInput from '@/views/pledge/components/CityInput.vue'

import {
  data_user_operation_log_in
} from '@/api/operationLog.js'
import dataReports from "@/mixins/dataReports";
import cityLaction from './cityLaction.js'

import {
  debounce
} from '@/utils/index.js'
export default {
  components: {
    // ComInput,
    ControlMap,
  },
  mixins: [dataReports],

  data() {
    return {
      // CityLaction: cityLaction,//城市市政府对应经纬度
      loading: false,
      communityNameList: [],
      noDataText: '找不到你想要的小区',
      mapAllowClick: true,// 小区是否允许点击
      searchloading: false,
      inputLpName: '',
      communityName: '',
      city: '',
      spinShow: false,//加载动画
      cityObj: JSON.parse(sessionStorage.getItem('cityObj')),
      cityList: JSON.parse(sessionStorage.getItem('cityList')),
      map: null,
      mapData: {//初始数据1
        timer: null,
        zoom: 17.5,
        center: {
          lng: 113.335593,
          lat: 23.119767,
        },
      },
      foShanCenter: {//佛山市政府经纬度
        lng: 113.128212,
        lat: 23.027216
      },
      dongGuanCenter: {//东莞市政府经纬度
        lng: 113.758184,
        lat: 23.027314
      },
      guangzhouCenter: {//广州市 中和广场经纬度
        lng: 113.335593,
        lat: 23.119767,
      },
      communityList: [//小区列表

      ],
      showScope: {
        SouthWest: {
          lng: 113.02996647899766,
          lat: 23.011918008667195,
        },
        NorthEast: {
          lng: 113.51289552100229,
          lat: 23.248279812734918,
        },
        zoom: 17.5,
      },
    };
  },
  computed: {
    CityLaction() {
      return this.$store.state.cityLaction.cityLaction || localStorage.getItem('cityLaction')
    },
  },
  watch: {


  },
  created() {

  },
  mounted() {
    let { cityCode } = this.cityObj
    this.city = cityCode
    // this.mapData.center = this.CityLaction[this.cityObj.cityFullName]//根据城市名字匹配市政府经纬度
    let center = {
      lng: 113.335593,
      lat: 23.119767,
    }
    if (this.CityLaction[cityCode]) {
      center = this.CityLaction[cityCode];

      // center = this.CityLaction.find(item => item.cityCode == cityCode).laction;

    }
    this.mapData.center = {
      lat: center.lat,
      lng: center.lng
    };
    let params = this.$route.params
    if (params) {
      if (params.center) {
        if (params.center.lat) {

          this.mapData.center = params.center
        }
      }
    }
    // this.getCommunityList()

    this.loadMap()
  },
  methods: {

   changeMapCenter(center,communityName) {
this.mapData.center = center
this.communityName = communityName
    this.loadMap()

   },


    childCityChange(obj) {
      this.cityChange(obj.cityCode)
    },
    cityChange(cityCode) {
      this.cityList.map(item => {
        if (cityCode == item.cityCode) {
          this.cityObj = item
          sessionStorage.setItem('cityObj', JSON.stringify(item))
          this.$store.commit("changeCityObj", item)
        }
      })

      // this.mapData.center = this.CityLaction[this.cityObj.cityFullName]
      let center = {
        lng: 113.335593,
        lat: 23.119767,
      }
      if (this.CityLaction[cityCode]) {
        center = this.CityLaction[cityCode];

        // center = this.CityLaction.find(item => item.cityCode == cityCode).laction;

      }
      this.mapData.center = {
        lat: center.lat,
        lng: center.lng
      };
      // this.map.centerAndZoom(this.mapData.center, this.mapData.zoom)
      this.loadMap()

    },
    mapChange(type) {
      if (type == 'NORMAL') {
        this.map.setMapType(BMAP_NORMAL_MAP);
      } else {
        this.map.setMapType(BMAP_SATELLITE_MAP);

      }
    },
    inputLpNameChange(value) {
      let obj = {}
      this.communityList.map(item => {
        if (value == item.value) {
          obj = item
        }
      })
      this.communityName = obj.communityName
      const myPoint = new BMap.Point(
        obj.lpLngBaidu,
        obj.lpLatBaidu
      );
      // that.map.centerAndZoom(myPoint, 7);
      // 初始化地图， 设置中心点坐标和地图级别
      this.map.centerAndZoom(myPoint, 17.5);
    },
    remoteMethod(query) {
      // if (query == '') {
      //   this.getSelectHistory()
      // } else {
      //   this.showHistory = false

      // }
      //  this.communityList = []
      this.searchloading = false;
      if (query.length < 2) {
        return
      }
      if (query !== '') {
        if (this.timer) {
          clearTimeout(this.timer)
        }
        this.loading = true;

        this.timer = setTimeout(async () => {
          this.searchloading = true;

          // this.loading = true;
          let { cityCode } = this.cityObj
          let params = {
            condition: query,
            cityCode
          }
          let data = await communitySelectCondition(params)
          this.loading = false;
          this.searchloading = false;
          if (data.length == 0) {
            this.noDataText = '找不到你想要的小区'
            this.communityList = []
            this.inputLpName = ''
          }
          data.map(item => {
            // item.value = item.communityName
            item.value = item.lpCode
            item.label = item.communityName
            return item
          })
          this.communityList = data


        }, 1000)
      }
    },
    loadMap() {//初始化地图
      let that = this;
      that.map = new BMap.Map("Bmap1");
      const myPoint = new BMap.Point(
        that.mapData.center.lng,
        that.mapData.center.lat
      );
      // that.map.centerAndZoom(myPoint, 7);
      // 初始化地图， 设置中心点坐标和地图级别
      that.map.centerAndZoom(myPoint, that.mapData.zoom);
      that.map.enableScrollWheelZoom(true);
      this.map.addEventListener("moveend", this.moveend);
      this.map.addEventListener("zoomend", this.zoomend);
      this.map.addEventListener("dragend", this.dragend);
      this.map.addEventListener("dragstart", this.dragstart);
      // that.map.moveend()
      setTimeout(() => {
        this.getBounds(that.map);
      }, 100);



    },
    dragstart() {//拖拽开始
      this.mapAllowClick = false
    },
    dragend() {//拖拽结束
      setTimeout(() => {
        this.mapAllowClick = true
      }, 300);


    },
    moveend() {//移动结束
      let zoom = this.map.getZoom(); // 获取缩放级别

      if (zoom <= 16) {
        // this.map.clearOverlays();
        this.getAdministrativeRegionData()
      } else {
        setTimeout(() => {
          this.getBounds(this.map);
        }, 100);

      }
      //  this.getBounds(this.map);
    },
    zoomend() {//缩放结束
      let zoom = this.map.getZoom(); // 获取缩放级别

      this.map.clearOverlays();
      if (zoom <= 16) {
        // this.map.clearOverlays();
        this.getAdministrativeRegionData()
      } else {
        this.getBounds(this.map);

      }

    },

    async getAdministrativeRegionData() {//获取行政区数据
      let list = [

      ]
      let params = {
        cityCode: this.cityObj.cityCode
      }
      let data = await countyLocation(params)
      list = data
      //  countyLocation
      this.setAdminMark(list)
    },

    setAdminMark(list) {//绘制行政区地图
      let that = this
      this.map.clearOverlays();
      list.forEach(item => {
        let myPoint = new BMap.Point(item.lng, item.lat
        );
        let opts = {
          position: myPoint,
          offset: new BMap.Size(-20, -20)
        }
        let info = new BMap.Label(item.districtName, opts)
        info.setContent(
          `<div class="admin-mark-info-box">
            ${item.districtName}
          </div>`
        );
        info.setStyle({
          border: "none",
          borderRadius: "5px",
          backgroundColor: 'transparent',

        });
        info.addEventListener("click", () => {
          // that.goreidValuation(item)
          that.clickAdminMark(item)
        });
        //鼠标hover时也变颜色
        info.addEventListener("mouseover", () => {
          if (item.isHover) {
            return
          }
          info.setStyle({
            zIndex: 99999999999999
          });
          item.isHover = true
        });
        //鼠标离开时还原
        info.addEventListener("mouseout", () => {
          info.setStyle({
            zIndex: 10
          });
          item.isHover = false
        });
        this.map.addOverlay(info);
        // this.map.addOverlay(newInfo);
      });
    },
    clickAdminMark(item) {//点击行政区
      this.spinShow = true

      this.map.clearOverlays();
      const myPoint = new BMap.Point(
        item.lng,
        item.lat,
      );
      // that.map.centerAndZoom(myPoint, 7);
      // 初始化地图， 设置中心点坐标和地图级别
      this.map.centerAndZoom(myPoint, 17);

    },
    //获取地图数据
    getBounds(baidumap) {
      if (baidumap) {
        const Bounds = baidumap.getBounds();
        this.showScope.SouthWest = Bounds.getSouthWest();
        this.showScope.NorthEast = Bounds.getNorthEast();
        let point = Bounds.getCenter();
        // lngLatCommunityList

        //获取
        this.getCommunityList()
      }
    },
    async getCommunityList() {
      // this.$Spin.show()

      let { cityCode, provinceCode } = this.cityObj
      let params = {
        cityCode,
        provinceCode,
        isBaidu: true,
        points: []
      }
      let NorthEast = this.showScope.NorthEast
      let SouthWest = this.showScope.SouthWest
      let NE = {
        lng: NorthEast.lng.toString(),
        lat: NorthEast.lat.toString()
      }
      let SW = {
        lng: SouthWest.lng.toString(),
        lat: SouthWest.lat.toString()
      }
      params.points.push(NE)
      params.points.push(SW)
      lngLatCommunityList(params).then(res => {
        this.communityNameList = res
        this.setMark(res)
        this.spinShow = false


      }).catch(err => {
        // this.spinShow = false
      })

    },
    setMark(list) {
      let that = this
      this.map.clearOverlays();
      const debouncedGetCommunityList = debounce(this.getCommunityList, 500);
      let selectItem = {}
      list.forEach(item => {
        let myPoint = new BMap.Point(item.center.lpLngBaidu, item.center.lpLatBaidu
        );
        let opts = {
          position: myPoint,
          offset: new BMap.Size(-20, -20)
        }
        let info = new BMap.Label(item.communityName, opts)


        if (this.communityName == item.communityName) {
          selectItem = item
          info.setContent(
            `<div class="map-info-box-1 map-info-yellow">
            ${item.communityName}
          </div>`
          );
          info.setStyle({
            borderColor: "#FF8000",
            backgroundColor: '#FF8000',
            zIndex: 99999999999999
          });


        } else {
          info.setContent(
            `<div class="map-info-box-1">
            ${item.communityName}
          </div>`
          );

        }
        info.setStyle({
          border: "none",
          borderRadius: "5px",
          backgroundColor: 'transparent',
        });
        info.addEventListener("click", () => {
          that.goreidValuation(item)
        });
        //鼠标hover时也变颜色
        info.addEventListener("mouseover", () => {
          if (item.isHover) {
            return
          }
          info.setStyle({
            zIndex: 999999999999
          });
          item.isHover = true
        });
        //鼠标离开时还原
        info.addEventListener("mouseout", () => {
          if (this.communityName == item.communityName) {
            info.setStyle({
              zIndex: 9999999999999
            });
          } else {
            info.setStyle({
              zIndex: 10
            });
          }
          item.isHover = false
        });
        this.map.addOverlay(info);
        // this.map.addOverlay(newInfo);
      });



    },
    goreidValuation(item) {
      this.mapAllowClick = true
      if (!this.mapAllowClick) {//表示是拖拽地图
        return
      }
      let that = this
      let _params = {
        event: 'click',
        isButton: false,
        log: JSON.stringify(item.communityName),
        os: navigator.userAgent,
        platform: '数据平台PC',
        route: that.$route.path,
        title: that.$route.meta.title,
        token: that.$store.state.token ? that.$store.state
          .token : '',
        user_id: that.$store.state.userId ? that.$store
          .state
          .userId : '',
      }
      data_user_operation_log_in(_params)
      let params = {
        center: item.center,
        cityCode: item.cityCode,
        communityName: item.communityName,
        lpCode: item.lpCode,
      }
      that.communityName = item.communityName
      // setTimeout(() => {
      //    // 重新绘制地图
      //     that.getCommunityList();
      // }, 500);
      this.setMark(that.communityNameList)

      this.$emit('goReidValuation', params)

      // this.$router.push({
      //   name: '立即估价',
      //   params: params
      // })
    },
  }
};
</script>

<style scoped lang="scss">
.parentheses {
  width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  // display: -webkit-box;
}

.el-box {
  display: flex;
  justify-content: space-between;
  // width: 420px;
}

.body-box {
  background: #EFF1F6;
  height: 100%;
  min-height: 100%;
  padding: 24px;

  .main-content {
    background: #FFFFFF;
    // height: 100%;
    min-height: 100%;
     min-width: 600px;
    border-radius: 10px 10px 10px 10px;
    padding: 24px;

    .city-selcet {

      position: absolute;
      left: 68px;
      top: 80px;
      width: 420px;

      z-index: 10;
    }

    .input-box {
      position: absolute;
      left: 68px;
      top: 120px;
      width: 420px;

      z-index: 9;

    }

    .contro-map {
      position: absolute;
      right: 100px;
      bottom: 70px;
    }
  }


}

#Bmap1 {
  height: 100%;
  min-height: 870px;
  width: 100%;
  background: #eee;
  border-radius: 10px;

}



</style>

